/* eslint-disable */
/**
 * Mock for embla-carousel-react
 *
 * Embla is a DOM-based carousel library that requires browser APIs.
 * In SSR, tests, or certain bundling environments it can fail because
 * it expects window/document and layout measurements.
 *
 * This mock provides a minimal implementation of the hook so components
 * using it can render without errors.
 */

import React from 'react';

// Fake API object
const createEmblaApi = () => ({
  scrollNext: () => {},
  scrollPrev: () => {},
  scrollTo: () => {},
  canScrollNext: () => false,
  canScrollPrev: () => false,
  selectedScrollSnap: () => 0,
  scrollSnapList: () => [],
  on: () => {},
  off: () => {},
  destroy: () => {},
  reInit: () => {},
  slidesInView: () => [],
  slidesNotInView: () => [],
});

// Mock hook
function useEmblaCarousel() {
  const ref = React.useCallback(() => {}, []);
  const api = React.useMemo(() => createEmblaApi(), []);
  return [ref, api];
}

// Optional helpers some libs import
export const EmblaCarouselReact = () => null;

export default useEmblaCarousel;
